// extracted by mini-css-extract-plugin
module.exports = {"group":"form_group_group__35Vdf","title":"form_group_title__2aPa-","content":"form_group_content__2N3IZ"};